// Shared 18x18 line-icon set so the sidebar, stat tiles, and charts draw
// from one visual language instead of every page hand-rolling its own SVGs.
export const IconGrid = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <rect x="2" y="2" width="6" height="6" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
    <rect x="10" y="2" width="6" height="6" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
    <rect x="2" y="10" width="6" height="6" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
    <rect x="10" y="10" width="6" height="6" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
export const IconFolder = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <path d="M2 4.5A1.5 1.5 0 0 1 3.5 3h3.4l1.3 1.6h6.3A1.5 1.5 0 0 1 16 6.1v7.4A1.5 1.5 0 0 1 14.5 15h-11A1.5 1.5 0 0 1 2 13.5V4.5Z"
      stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);
export const IconList = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <path d="M6 5h9M6 9h9M6 13h9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="3" cy="5" r="1" fill="currentColor" />
    <circle cx="3" cy="9" r="1" fill="currentColor" />
    <circle cx="3" cy="13" r="1" fill="currentColor" />
  </svg>
);
export const IconChart = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <path d="M3 15V9M9 15V3M15 15v-5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
  </svg>
);
export const IconCheck = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="1.5" />
    <path d="M6 9.2l2 2 4-4.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const IconTransfer = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <path d="M5 12.5V3m0 0L2.2 5.8M5 3l2.8 2.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 5.5V15m0 0l2.8-2.8M13 15l-2.8-2.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const IconUsers = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <circle cx="6.5" cy="6" r="2.4" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2 15c0-2.4 2-4 4.5-4s4.5 1.6 4.5 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="13" cy="6.5" r="1.9" stroke="currentColor" strokeWidth="1.4" />
    <path d="M11.6 15c-.1-2 1.4-3.6 3.4-3.6 1.6 0 3 1 3.3 2.6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);
export const IconUser = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <circle cx="9" cy="6.3" r="3" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2.8 15.2c.6-3.1 3.1-5 6.2-5s5.6 1.9 6.2 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
export const IconActivity = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <path d="M1.5 9.5h3l1.8-5.5L9.8 14 12 6.5l1.4 3h3.1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const IconSun = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <circle cx="9" cy="9" r="3.2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M9 1.6v2M9 14.4v2M16.4 9h-2M3.6 9h-2M14.2 3.8l-1.4 1.4M5.2 12.8l-1.4 1.4M14.2 14.2l-1.4-1.4M5.2 5.2 3.8 3.8"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
export const IconAlert = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <path d="M9 2.3 16.3 15H1.7L9 2.3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M9 7v3.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="9" cy="12.6" r="0.9" fill="currentColor" />
  </svg>
);
export const IconCard = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <rect x="1.5" y="4" width="15" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M1.5 7.2h15" stroke="currentColor" strokeWidth="1.5" />
    <path d="M4 10.8h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
export const IconKey = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <circle cx="6" cy="12" r="3.2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M8.3 9.7 15 3M15 3v3M15 3h-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const IconWebhook = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <path d="M10 2 4 10h4l-1 6 7-9h-4l1-5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);
export const IconMoon = () => (
  <svg viewBox="0 0 18 18" fill="none" className="h-4 w-4 shrink-0">
    <path d="M15.5 10.8A6.5 6.5 0 1 1 7.2 2.5a5.2 5.2 0 0 0 8.3 8.3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);
